import { render } from "./datalayer-update.vue?vue&type=template&id=3a22e699"
import script from "./datalayer-update.vue?vue&type=script&lang=js"
export * from "./datalayer-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__